module.exports = __webpack_public_path__ + "static/media/bim_photo.7fc9575f.jpg";